/** Права ролей. Один список — і сервер, і інтерфейс звіряються з ним. */
export const CAPABILITIES = [
    'marks.view',
    'marks.edit',
    'people.view',
    'people.edit',
    'documents.generate',
    'templates.manage',
    'settings.view',
    'settings.edit',
    'users.manage',
    'org.manage',
    'orgs.manage',
    'bot.manage',
    'audit.view',
    'data.export',
    'data.import',
];
const ALL = new Set(CAPABILITIES);
const MATRIX = {
    // Власник — над курсами: бачить усі, створює нові й призначає адміністраторів.
    owner: ALL,
    // Адміністратор відповідає за свій курс: усе всередині нього, крім самих курсів.
    admin: new Set([
        'marks.view', 'marks.edit', 'people.view', 'people.edit',
        'documents.generate', 'templates.manage', 'settings.view', 'settings.edit',
        'org.manage', 'users.manage', 'bot.manage', 'audit.view', 'data.export', 'data.import',
    ]),
    // Діловод веде щоденну роботу; налаштування лише читає, доки адміністратор
    // не відкриє йому правку (`settingsAccess`).
    clerk: new Set([
        'marks.view', 'marks.edit', 'people.view', 'people.edit',
        'documents.generate', 'settings.view', 'data.export',
    ]),
};
/** Права, які адміністратор курсу відкриває діловоду окремо. */
const SETTINGS_GRANT = ['settings.edit'];
export const capabilitiesOf = (who) => {
    const s = typeof who === 'string' ? { role: who } : who;
    const caps = new Set(MATRIX[s.role] ?? []);
    if (s.role === 'clerk' && s.settingsAccess)
        for (const c of SETTINGS_GRANT)
            caps.add(c);
    return [...caps];
};
export const can = (who, cap) => capabilitiesOf(who).includes(cap);
export const ROLE_LABELS = {
    owner: 'Власник',
    admin: 'Адміністратор курсу',
    clerk: 'Діловод',
};
export const ROLE_HINTS = {
    owner: 'Бачить усі курси, створює нові й призначає адміністраторів.',
    admin: 'Відповідає за свій курс: налаштування, бланки, бот і діловоди.',
    clerk: 'Веде таблицю та формує документи; налаштування читає, а правити може лише з дозволу адміністратора.',
};
/** Кого може створювати й правити користувач із цією роллю. */
export const MANAGEABLE_ROLES = {
    owner: ['owner', 'admin', 'clerk'],
    admin: ['clerk'],
    clerk: [],
};
export const canManageRole = (actor, target) => MANAGEABLE_ROLES[actor]?.includes(target) ?? false;
//# sourceMappingURL=permissions.js.map